import { render } from "./tw-video.vue?vue&type=template&id=6f51da80"
import script from "./tw-video.vue?vue&type=script&lang=js"
export * from "./tw-video.vue?vue&type=script&lang=js"
script.render = render

export default script